import { NgModule } from '@angular/core';
import { NotificationList} from './notification-list.component'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { LoadingSpinnerModule } from '@app/components/utils/loading-spinner.module';
import { SharedModule } from '@app/shared';
import { NotificationModalModule } from '@modules/notification/components/notification-modal/notification-modal.module';


@NgModule({
  declarations: [
    NotificationList
  ],
  imports: [
    SharedModule,
    BsDropdownModule,
    NotificationModalModule,
    LoadingSpinnerModule
  ],
  exports: [
    NotificationList
  ],
  providers: [
  ]
})
export class NotificationListModule { }
